import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const KeyBenefits: React.FC = () => {
  const context = useContext(ProductContext);

  // Ensure context and product exist
  if (!context || !context.product) {
    return null;
  }

  // Filter out empty or whitespace-only strings
  const benefits =
    context.product.keyBenefits?.filter((benefit) => benefit.trim() !== "") || [];

  // If there are no valid benefits, don't render the component
  if (benefits.length === 0) {
    return null;
  }

  const headingColor = context.product.headingColor || "#000000";
  const textColor = context.product.textColor || "#000000";
  const headingFontStyle = context.product.headingFontStyle;
  const fontStyle = context.product.fontStyle;

  return (
    <div className="w-full max-w-2xl mx-auto px-4 pb-5 font-mulish text-left">
      <h2
        style={{ letterSpacing: "0.01em", color: headingColor, fontFamily: headingFontStyle }}
        className="text-base font-bold leading-tight pb-2"
      >
        Key Benefits
      </h2>
      <ul className="mt-2 text-sm text-gray-900 leading-snug space-y-2">
        {benefits.map((benefit, index) => (
          <li style={{ color: textColor, fontFamily: fontStyle }} key={index} className="flex items-start">
            <span className="mr-2">{index + 1}.</span>
            {benefit}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default KeyBenefits;
